/**
 * Header component
 *
 * Top navigation bar for your site. Set to remain visible as the
 * user scrolls so that they can constantly reach any part of your page.
 */
import React from "react";
import cvFile from "url:../../mahdi_abu_tafish_cv.pdf";

const Header = () => {
  return (
    <header className="site-header">
      <a href="#home" className="brand-mark" aria-label="Go to top of page">
        MA
      </a>
      <nav className="site-nav" aria-label="Primary navigation">
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#certifications">Certifications</a>
        <a href="#portfolio">Work</a>
        <a href="#footer">Contact</a>
        <a href={cvFile} download="mahdi_abu_tafish_cv.pdf">
          Download CV
        </a>
      </nav>
    </header>
  );
};

export default Header;
